import { render, staticRenderFns } from "./registerDetailDialog.vue?vue&type=template&id=514ef568&scoped=true"
import script from "./registerDetailDialog.vue?vue&type=script&lang=js"
export * from "./registerDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./registerDetailDialog.vue?vue&type=style&index=0&id=514ef568&prod&lang=less"
import style1 from "./registerDetailDialog.vue?vue&type=style&index=1&id=514ef568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ef568",
  null
  
)

export default component.exports